import React, { useState, useEffect } from 'react';
import Aos from 'aos';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import ScholarshipImage from '../../assets/images/statue-of-liberty-1210001_1920.jpg';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  topImageContainer: {
    overflow: 'hidden',
  },
  media: {
    position: 'relative',
    paddingBottom: '38.25%',
    backgroundSize: 'cover',
  },
  explanationBlock: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '2rem',
  },
  explanation: {
    lineHeight: '2rem',
    padding: '0.5rem 1rem',
    color: '#fff',
    textShadow: '0px 0.5px 5px black',
    fontWeight: 200,
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: 18,
    textAlign: 'center'
  },
  icon: {
    fontSize: '2rem',
    margin: '1rem 0',
    color: '#fff',
    textShadow: '0px 1px 3px black',
    /* prevent icon layer from intercepting clicks */
    pointerEvents: 'none',
  },
  iconSmall: {
    fontSize: '1.5rem',
    margin: '1rem',
    color: '#fff',
    textShadow: '0px 1px 3px black',
    /* prevent icon layer from intercepting clicks */
    pointerEvents: 'none',
  },
  apply: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '1.5rem',
  },
  /* style <a> like a button to avoid nested interactive elements */
  button: {
    position: 'relative',
    zIndex: 2,
    pointerEvents: 'auto',
    display: 'inline-block',
    margin: '1rem',
    padding: '0.75rem 1.5rem',
    fontSize: 'medium',
    background: '#15678D',
    border: 'none',
    color: '#fff',
    marginBottom:'1rem',
    textDecoration: 'none',
    borderRadius: '0.2rem',
    boxShadow: '0 0 10px 5px #fff',
    transition: '0.3s ease-in-out',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#fff',
      border: '1px solid #fff',
      color: '#34455E',
      boxShadow: '0 0 15px 2px #34455E',
    },
    '&:focus': {
      outline: '2px solid #fff',
      outlineOffset: '2px',
    },
  },
  grantCard: {
    background: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '10px',
    padding: '1rem',
    textAlign: 'center',
    boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
    color: '#fff',
    fontFamily: 'Arial, Helvetica, sans-serif',
    textShadow: '0px 0.5px 3px black',
    fontSize: '1.2rem',
    minHeight: '160px',
    width: '90%',
  },
  titleBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '1.8rem',
    fontWeight: 'bold',
    textShadow: '0 1px 3px black',
    marginBottom: '2.5rem',
    flexWrap: 'wrap',
    textAlign: 'center',
  },
}));

const grants = [
  { term: 'Spring 2021', scholars: 15 },
  { term: 'Fall 2021', scholars: 17 },
  { term: 'Spring 2022', scholars: 21 },
  { term: 'Fall 2022', scholars: 26 },
  { term: 'Spring 2023', scholars: 29 },
  { term: 'Fall 2023', scholars: 27 },
  { term: 'Spring 2024', scholars: 24 },
  { term: 'Fall 2024', scholars: 48 },
  { term: 'Spring 2025', scholars: 55 },
];

const testimonialText1 = '"Dear BlueTulip Team, I want to sincerely thank you for awarding me this scholarship. I am incredibly grateful for your support, as it not only eases the financial burden but also motivates me to work even harder toward my academic and career goals. Your generosity is truly inspiring, and I am deeply honored to be a recipient.';
const testimonialText2 = 'I would also like to extend my heartfelt thanks to all the individuals who have donated to BlueTulips. Your contributions make a profound impact on students like me, and I am deeply appreciative of your belief in our potential. This scholarship means so much to me, and I want you to know how much I appreciate the trust and confidence you’ve placed in me. I am committed to making the most of this opportunity and striving for excellence in all that I do.';
const testimonialText3 = 'Thank you once again for your kindness, support, and for making such a positive difference in my education."';

const Scholarship = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const imageUrl = ScholarshipImage;
  const classes = useStyles();

  useEffect(() => {
    Aos.init({
      duration: 800,   // smoother and less intrusive
      once: true,      // don’t keep re-animating while idle
      offset: 120,
      easing: 'ease-out'
    });
  }, []);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
      // Keep AOS metrics fresh after resizes/rotations
      try { Aos.refreshHard(); } catch {}
    };
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return (
    <div className={classes.topImageContainer}>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12}>
          <CardMedia
            className={classes.media}
            style={{ backgroundImage: `url(${imageUrl})` }}
            component="div"
          >
            <div className={classes.explanationBlock}>
              <div className={classes.titleBar}>
                <i className="fas fa-university" style={{ marginRight: '0.5rem', pointerEvents: 'none' }}></i>
                Blue Tulip Scholarship
              </div>

              <Grid container spacing={3}>
                <Grid item xs={11} md={6}>
                  <Grid container spacing={2} justifyContent="center">
                    {grants.map((grant, index) => (
                      <Grid item xs={6} sm={5} md={4} key={index}>
                        <br />
                        <div className={classes.grantCard} style={{ marginLeft: '2rem', marginRight: '2rem' }}>
                          <br />
                          <div>{grant.term}</div>
                          <div style={{ fontSize: '2rem', fontWeight: 'bold' }}>{grant.scholars}</div>
                          <div>scholars</div>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Grid item xs={12} sm={10} md={10}>
                    {/* Testimonial - unchanged */}
                    <div className={classes.icon} style={{ marginLeft: '2rem' }}>
                      <i className="fas fa-quote-left"></i>
                    </div>
                    <p
                      style={{
                        fontFamily: 'Georgia, serif',
                        fontStyle: 'italic',
                        fontSize: windowWidth < 600 ? '1rem' : '1.1rem',
                        lineHeight: windowWidth < 600 ? '1.5rem' : '1.8rem',
                        color: '#fff',
                        textShadow: '0px 1px 3px black',
                        marginLeft: '2rem',
                        marginRight: '2rem',
                        marginBottom: '4rem',
                      }}
                    >
                      {testimonialText1}<br />{testimonialText2}<br />{testimonialText3}
                    </p>

                    {/* Donate row */}
                    <div style={{ display: 'flex', alignItems: 'center', margin: '0 2rem 1rem 2rem' }}>
                      <div className={classes.icon} style={{ marginRight: '0.75rem' }}>
                        <i className="fas fa-user-graduate"></i>
                      </div>
                      <div className={classes.explanation}>
                        We will continue to support exceptional students in the fulfillment of their potentials.
                      </div>
                    </div>
                    <div className={classes.apply} style={{ marginLeft: '2rem', marginBottom: '2rem' }}>
                      <a href="/donate" className={classes.button} role="button" aria-label="Donate for Scholarship">
                        Donate for Scholarship
                      </a>
                    </div>

                    {/* Apply row */}
                    {/* <div
                      data-aos={windowWidth > 1024 ? 'zoom-in' : 'fade-up'}
                      style={{ display: 'flex', alignItems: 'center', margin: '0 2rem 1rem 2rem' }}
                    >
                      <div className={windowWidth > 1024 ? classes.icon : classes.iconSmall} style={{ marginRight: '0.75rem' }}>
                        <i className="fas fa-user-graduate"></i>
                      </div>
                      <div data-aos="fade-up" className={classes.explanation}>
                        Apply for Fall 2026 Blue Tulip Scholarship Program!
                      </div> 
                    </div>
                    <div className={classes.apply} style={{ marginLeft: '2rem' }}>
                      <a href="/scholarship/signin" className={classes.button} role="button" aria-label="Apply Now">
                        Apply Now
                      </a>
                    </div>  */}
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <div className={classes.explanation}>
                  If you have any questions about the program, please email us at &nbsp;
                  <span style={{ color: '#1D58A8', textShadow: '1px 1px 3px white' }}>
                    scholarship@blue-tulip.org
                  </span>
                </div>
              </Grid>
            </div>
          </CardMedia>
        </Grid>
      </Grid>
    </div>
  );
};

export default Scholarship;
